/**
 * Lookups read-only (sin CRUD UI todavía) para llenar selects del form de productos.
 * Cuando agreguemos las páginas admin de cada uno, se reusan los mismos query keys.
 */

import { useQuery } from "@tanstack/react-query";

import { api } from "@/lib/api.ts";
import type { BrandOut, CategoryOut, UnitOut } from "@/types/api.ts";

export const lookupKeys = {
  categories: ["admin", "lookups", "categories"] as const,
  brands: ["admin", "lookups", "brands"] as const,
  units: ["admin", "lookups", "units"] as const,
};

export function useCategoriesLookup() {
  return useQuery({
    queryKey: lookupKeys.categories,
    queryFn: () => api.get<CategoryOut[]>("/categories"),
    staleTime: 60_000,
  });
}

export function useBrandsLookup() {
  return useQuery({
    queryKey: lookupKeys.brands,
    queryFn: () => api.get<BrandOut[]>("/brands"),
    staleTime: 60_000,
  });
}

export function useUnitsLookup() {
  return useQuery({
    queryKey: lookupKeys.units,
    queryFn: () => api.get<UnitOut[]>("/units"),
    staleTime: 60_000,
  });
}
